import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isAsyncValidating, isDirty, isSubmitting, submit as submitAction, } from 'redux-form';
import { propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import { onClickSubmitCheck } from '../../../../helpers/form';
import SubmitButton from '../../Button/SubmitButton';
class FormConsultantProfileSticky extends Component {
    constructor(props) {
        super(props);
        this.onClick = (e, state, isPreview) => {
            this.window = null;
            const { setOnSubmitCompleteCallback, submit, thisForm } = this.props;
            setOnSubmitCompleteCallback(this.onSubmitCompleteCallback);
            const result = onClickSubmitCheck(thisForm)(e);
            if (result) {
                this.setState(state);
                if (isPreview) {
                    this.window = window.open('', `profile_${new Date().getTime()}`);
                    this.window.document.body.innerHTML = 'loading...';
                }
            }
            submit();
        };
        this.onClickPreview = (e) => {
            const { dirty } = this.props;
            if (dirty) {
                // 変更がある場合は一旦ページを開く
                this.onClick(e, { onDoingPreview: true }, true);
            }
            else {
                // 変更がない場合はそのまま
                window.open(this.getPreviewUrl(), '_blank');
            }
        };
        this.onClickSubmit = (e) => {
            this.onClick(e, { onDoingSubmit: true }, false);
        };
        this.onSubmitCompleteCallback = (result) => {
            this.setState({
                onDoingPreview: false,
                onDoingSubmit: false,
            });
            if (result && this.window) {
                this.window.location.href = this.getPreviewUrl();
            }
        };
        this.getPreviewUrl = () => {
            const { previewUrl } = this.props;
            return previewUrl;
        };
        this.state = {
            onDoingPreview: false,
            onDoingSubmit: false,
        };
        this.window = null;
    }
    render() {
        const { asyncValidating, submitting } = this.props;
        const { onDoingPreview, onDoingSubmit } = this.state;
        return (_jsx("div", Object.assign({ className: 'sticky-footer' }, { children: _jsxs("div", Object.assign({ className: 'footer-action' }, { children: [_jsx(SubmitButton, { buttonType: 'button', className: 'link-text', isDisabled: asyncValidating || submitting, isLoading: onDoingPreview, onControlClick: this.onClickPreview, tabIndex: 0, text: 'プレビュー' }), _jsx(SubmitButton, { buttonType: 'button', className: 'btn btn-new-primary centered medium btn-save-i is-full', isDisabled: asyncValidating || submitting, isLoading: onDoingSubmit, onControlClick: this.onClickSubmit, tabIndex: 0, text: _jsxs(_Fragment, { children: [_jsx("i", Object.assign({ className: 'material-icons md-14' }, { children: "save_alt" })), "\u4FDD\u5B58\u3059\u308B"] }) })] })) })));
    }
}
FormConsultantProfileSticky.propTypes = {
    asyncValidating: propBool().isRequired,
    dirty: propBool().isRequired,
    previewUrl: propStr().isRequired,
    setOnSubmitCompleteCallback: propFunc().isRequired,
    submit: propFunc().isRequired,
    submitting: propBool().isRequired,
    thisForm: propShape(),
};
FormConsultantProfileSticky.defaultProps = {
    thisForm: {},
};
const mapStateToProps = (state, { formName }) => ({
    asyncValidating: isAsyncValidating(formName)(state),
    dirty: isDirty(formName)(state),
    submitting: isSubmitting(formName)(state),
    thisForm: state.form[formName],
});
const mapDispatchToProps = (dispatch, { formName }) => ({
    submit: () => dispatch(submitAction(formName)),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
const OuterFormConsultantProfileSticky = enhance(FormConsultantProfileSticky);
OuterFormConsultantProfileSticky.propTypes = {
    formName: propStr().isRequired,
    previewUrl: propStr().isRequired,
    setOnSubmitCompleteCallback: propFunc().isRequired,
};
export default OuterFormConsultantProfileSticky;
